import Vue from 'vue';
// import _ from 'lodash';
import {
    GET_RECNET_CARNO_REQUEST,
    GET_RECNET_CARNO_SUCCESS,
    GET_RECNET_CARNO_FAILURE,
} from '../mutationTypes';

const state = {
    loading: false,
    usedCarNo: [],
};
const mutations = {
    [GET_RECNET_CARNO_REQUEST](state) {
        state.loading = true;
    },
    [GET_RECNET_CARNO_SUCCESS](state, res) {
        state.loading = false;
        state.usedCarNo = res;
    },
    [GET_RECNET_CARNO_FAILURE](state) {
        state.loading = false;
    }
};

export const actions = {
    // async getRecentCarNo({ commit }) {
    //     Vue.$storage.init();
    //     commit(GET_RECNET_CARNO_REQUEST);

    //     Vue.$storage.getLocal('CAR_NUM_CACHE').then(async (rCarNo) => {
    //         if (_.isEmpty(rCarNo)) {
    //             const res = await Vue.$ajax.get('carNumUsed');

    //             if (!res.errorType) {
    //                 Vue.$storage.update('CAR_NUM_CACHE', res);
    //                 commit(GET_RECNET_CARNO_SUCCESS, res);
    //             } else {
    //                 commit(GET_RECNET_CARNO_FAILURE);
    //             }
    //         } else {
    //             commit(GET_RECNET_CARNO_SUCCESS, rCarNo);
    //         }
    //     }).catch(async () => {
    //         const res = await Vue.$ajax.get('carNumUsed');

    //         if (!res.errorType) {
    //             Vue.$storage.update('CAR_NUM_CACHE', res);
    //             commit(GET_RECNET_CARNO_SUCCESS, res);
    //         } else {
    //             commit(GET_RECNET_CARNO_FAILURE);
    //         }
    //     });
    // }

    async getRecentCarNo({ commit }, reqParams) {
        commit(GET_RECNET_CARNO_REQUEST);
        const res = await Vue.$ajax.get('carNumUsed', {carNo: reqParams});
        if (!res.errorType) {
            commit(GET_RECNET_CARNO_SUCCESS, res);
        } else {
            commit(GET_RECNET_CARNO_FAILURE);
        }
    },
};

export default {
    state,
    mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/recentCarNo.js